import EditorDropDownCard from "../../../UI/EditorDropDownCard";

export default function MediaToolbar({

    filters,

    onChange

}) {

   function handleChange(e) {

  const {
    name,
    value
  } = e.target;

  onChange?.({

    ...filters,

    [name]: value,

    ...(name !== "page" && {
      page: 1
    })

  });

}

    return (

        <div className="media-toolbar">

            <div className="toolbar-search">

                <input

                    className="toolbar-input"

                    type="text"

                    name="search"

                    placeholder="Search files..."

                    value={filters.search}

                    onChange={handleChange}

                />

            </div>
        <div className={"dropdownScroller"}>
          <EditorDropDownCard
  width="120px"
  hasDropDown={true}
  activeCard={false}
  icon={0}
  title={
    filters.mimeGroup
      ? {
          image: "Images",
          video: "Videos",
          audio: "Audio",
          document: "Documents"
        }[filters.mimeGroup]
      : "All Types"
  }onClickPopup={()=>{}}
  dropDownObjectI={[
    { id: 0, name: "All Types", value: "" },
    { id: 1, name: "Images", value: "image" },
    { id: 2, name: "Videos", value: "video" },
    { id: 3, name: "Audio", value: "audio" },
    { id: 4, name: "Documents", value: "document" }
  ]}
  
  onClickBackObject={(v) =>
    onChange?.({
      ...filters,
      mimeGroup: v.value,
      page: 1
    })
  }
/>
   <EditorDropDownCard
    width="100px"
    hasDropDown
    activeCard={false}
    icon={0}
    onClickPopup={()=>{}}
    title={{
        id:"Newest",
        created_at:"Created",
        original_name:"Name",
        size_bytes:"Size"
    }[filters.sort] || "Newest"}
    dropDownObjectI={[
        {
            id:0,
            name:"Newest",
            value:"id"
        },
        {
            id:1,
            name:"Created",
            value:"created_at"
        },
        {
            id:2,
            name:"Name",
            value:"original_name"
        },
        {
            id:3,
            name:"Size",
            value:"size_bytes"
        }
    ]}
    onClickBackObject={v=>

        onChange({

            ...filters,

            sort:v.value,

            page:1

        })

    }
/><EditorDropDownCard
    width="100px"
    hasDropDown
    activeCard={false}
    icon={0}
    onClickPopup={()=>{}}
    title={
        filters.order==="ASC"
            ?"Ascending"
            :"Descending"
    }
    dropDownObjectI={[
        {
            id:0,
            name:"Descending",
            value:"DESC"
        },
        {
            id:1,
            name:"Ascending",
            value:"ASC"
        }
    ]}
    onClickBackObject={v=>

        onChange({

            ...filters,

            order:v.value,

            page:1

        })

    }
/>         
<EditorDropDownCard
  width="120px"
  hasDropDown
  activeCard={false}
  icon={0}
  onClickPopup={()=>{}}
  title={filters.folder || "All Folders"}
  dropDownObjectI={[
    { id: 0, name: "All Folders", value: "" },
    { id: 1, name: "Documents", value: "documents" },
    { id: 2, name: "Products", value: "products" },
    { id: 3, name: "Content", value: "content" },
    { id: 4, name: "Assignments", value: "assignments" },
    { id: 5, name: "Certificates", value: "certificates" },
    { id: 6, name: "Users", value: "users" }
  ]}
  onClickBackObject={(v) =>
    onChange?.({
      ...filters,
      folder: v.value,
      page: 1
    })
  }
/></div>

<style>{`

.dropdownScroller{display:flex;justify-content:space-between;flex-wrap:wrap}
.media-toolbar{

    display:flex;

    gap:16px;

    align-items:center;

    margin:24px 0;

    flex-wrap:wrap;

}

.toolbar-search{

    flex:1;

    min-width:260px;

}

.toolbar-input{

    width:93%;

    height:46px;

    border:2px solid rgba(144, 202, 249,1);

    border-radius:12px;

    padding:0 18px;

    font-size:14px;

    background:#FFFFFF;

    transition:.25s;

}

.toolbar-input:focus{

    border-color:rgba(144, 202, 249,1);

    box-shadow:0 0 0 3px rgba(37,99,235,.12);

    outline:none;

}

.toolbar-select{

    min-width:170px;

    height:46px;

    border:1px solid #D7DCE3;

    border-radius:12px;

    background:#FFFFFF;

    padding:0 14px;

    font-size:14px;

    cursor:pointer;

    transition:.25s;

}

.toolbar-select:hover{

    border-color:rgba(144, 202, 249,1);

}

.toolbar-select:focus{

    outline:none;

    border-color:rgba(144, 202, 249,1);

    box-shadow:0 0 0 3px rgba(37,99,235,.12);

}`}</style>
        </div>

    );

}